import PortalIdParser from 'PortalIdParser';
export const getAssociationSettingsUrl = (objectTypeId, toObjectTypeId) => {
  return `/association-settings/${PortalIdParser.get()}?type=${encodeURIComponent(objectTypeId)}&selectedToObjectTypeId=${encodeURIComponent(toObjectTypeId)}`;
};